import { render, staticRenderFns } from "./SelectWholesaleAddress.vue?vue&type=template&id=5f734396"
import script from "./SelectWholesaleAddress.vue?vue&type=script&lang=js"
export * from "./SelectWholesaleAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports